import AuthService from "../../../services/authService";
import LoginService from "../../../../app/services/LoginService";
import Environment from "../../../../environments/environment";
import AbstractController from "../../../services/abstractController";
import ToastService from "../../../services/toastService";
import jwtDecode from "jwt-decode";
import ContribuinteService from "../../../../app/services/contribuinte.service";
import ConvidadosService from "../../../../app/services/convidados.service";

export default class LoginUnicoController extends AbstractController {
  public static readonly CALLBACK_LOGIN_UNICO = "callbackLoginUnico";

  private authService = new AuthService();
  private loginService = new LoginService();
  private contribuinteService = new ContribuinteService();
  private convidadosService = new ConvidadosService();

  constructor() {
    super();
  }

  async init() {
    super.init();
    const state = this.location.state;
    if (this.verificaLoginUnico()) {
      if (state) {
        this.setCookie(LoginUnicoController.CALLBACK_LOGIN_UNICO, state, 1);
        try {
          if (state.codAudienciaPublica) {
            sessionStorage.setItem(
              "codAudienciaPublica",
              state.codAudienciaPublica
            );
          }
          if (state.id !== null && state.id !== undefined) {
            sessionStorage.setItem("dispositivoId", String(state.id));
          }
        } catch {}
      } else {
        this.setCookie(LoginUnicoController.CALLBACK_LOGIN_UNICO, {}, 1);
      }
      this.loginService.getRedirectUrl().then((url) => {
        window.location.href = url;
      });
      return;
    }
    if (this.verificaCode()) {
      await this.verificaContribuinte();
      return;
    }
  }

  private async verificaContribuinte() {
    const parametros = this.obtemParametrosAutenticacao();
    this.start();
    try {
      const dadosLoginUnico: any = (
        await this.loginService.loginUnico(
          parametros.code,
          Environment.getLoginUnicoCodeChallenge()
        )
      ).result;
      const idToken: any = jwtDecode(dadosLoginUnico.govBrIdToken);
      const contribuinte: any =
        await this.contribuinteService.existeContribuinte({
          nuInscricao: idToken.sub,
          noRazaoSocial: idToken.name,
          dsEmail: idToken.email,
          nivelSeloConfiabilidade: 3,
        });
      const data = {
        dadosLoginUnico,
        contribuinte,
      };
      this.loginService.salvarDadosLoginUnico({
        dadosLoginUnico: dadosLoginUnico,
        contribuinte: contribuinte.result,
      });

      let redirectedByInvite = false;
      let attemptedInviteValidation = false;
      try {
        const cpf = dadosLoginUnico?.token?.cpf;
        if (cpf) {
          attemptedInviteValidation = true;
          redirectedByInvite = await this.validarConviteSeExistir(
            cpf,
            idToken.email
          );
        } else {
          console.warn("CPF não encontrado no token para validação de convite");
        }
      } catch (error) {
        console.error("Erro na validação de convite:", error);
      }

      if (
        !redirectedByInvite &&
        attemptedInviteValidation &&
        !!sessionStorage.getItem("tokenInvite") &&
        !!sessionStorage.getItem("codAudienciaPublica")
      ) {
        sessionStorage.removeItem("tokenInvite");
        this.setCookie(LoginUnicoController.CALLBACK_LOGIN_UNICO, {}, 1);
        this.stop();
        this.history.push("/home");
        return;
      }

      if (redirectedByInvite) {
        this.stop();
        if (!contribuinte.success) {
          this.history.push("/completar", data);
        }
        return;
      }

      if (!contribuinte.success) {
        this.history.push("/completar", data);
      } else {
        const hadInvite = !!sessionStorage.getItem("tokenInvite");
        if (!hadInvite) {
          const callbackState =
            this.getCookie(LoginUnicoController.CALLBACK_LOGIN_UNICO) || {};
          const codAudienciaPublica =
            callbackState?.codAudienciaPublica ||
            sessionStorage.getItem("codAudienciaPublica");
          const dispositivoId =
            callbackState?.id || sessionStorage.getItem("dispositivoId");

          if (codAudienciaPublica && dispositivoId) {
            this.history.push("/evento/contribuicao", {
              id: Number(dispositivoId),
              codAudienciaPublica: codAudienciaPublica,
            });
          } else if (codAudienciaPublica) {
            this.history.push("/evento/visualizar", {
              id: codAudienciaPublica,
            });
          } else {
            this.history.push("/perfil/inicio");
          }

          this.setCookie(LoginUnicoController.CALLBACK_LOGIN_UNICO, {}, 1);
          sessionStorage.removeItem("dispositivoId");
        }
      }
      this.stop();
    } catch (err: any) {
      this.catchRequest();
    }
  }

  private catchRequest() {
    this.stop();
    ToastService.showError("Falha ao autenticar com login único.");
    this.history.push("/");
  }

  public obtemParametrosAutenticacao() {
    const params = this.extractSearchParams(window.location.search);
    return {
      code: params.code,
      state: params.state,
    };
  }

  private verificaLoginUnico() {
    return !this.authService.isAuthenticated() && !this.verificaCode();
  }

  private verificaCode() {
    const urlAtual = window.location.href;
    return urlAtual.indexOf("code") >= 0;
  }

  private async validarConviteSeExistir(
    cpf: string,
    email: string
  ): Promise<boolean> {
    if (!cpf) {
      console.warn(
        "CPF não encontrado no token — validação de convite cancelada."
      );
      return false;
    }

    const tokenInvite = sessionStorage.getItem("tokenInvite");
    if (!tokenInvite) {
      console.info("Nenhum token de convite encontrado no sessionStorage.");
      return false;
    }

    const payload = {
      dsToken: tokenInvite,
      dsNumeroDoc: cpf,
      stTipo: 0,
      dsEmail: email,
    };

    const tipoToken = sessionStorage.getItem("tipoToken");
    let resultado: any = null;
    try {
      if (tipoToken === "Tomada de Subsídios") {
        resultado = await this.convidadosService.validarConviteTomadaSubsidio(
          payload
        );
      } else {
        resultado = await this.convidadosService.validarConvite(payload);
      }

      if (resultado) {
        const callbackState = sessionStorage.getItem("codAudienciaPublica");
        const codAudienciaPublica = callbackState;
        if (codAudienciaPublica) {
          this.history.push("/evento/visualizar", { id: codAudienciaPublica });
          return true;
        }
      } else {
        console.error("Erro na validação do convite:", resultado);
      }
    } catch (error) {
      console.error("Erro inesperado ao validar convite:", error);
    }

    return false;
  }
}
